<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.billinghistory') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <BaseTable
        :pagination="pagination"
        class="custom-table"
        tableClass="table-bordered"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th>{{ $t('apps.billing.label.detail') }}</th>
              <th
                class="text-center"
                style="width: 400px;">{{ $t('apps.payment.label.ordernumber') }}</th>
              <th
                class="text-center"
                style="width: 200px;">{{ $t('apps.billing.label.paiddate') }}</th>
              <th
                class="text-right"
                style="width: 200px;">{{ $t('apps.billing.label.payamount') }}</th>
              <th
                style="width: 140px;"
                class="text-center">{{ $t('apps.billing.label.download') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="empty"
                colspan="5"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in transformData"
              :key="index"
            >
              <td>
                {{ item.description }}
              </td>
              <td class="text-center">
                {{ item.chargeId }}
              </td>
              <td class="text-center">
                {{ getDateCustom(item.paidAt, { format: 'YYYY-MM-DD H:m:s' }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(item.paidAmount, '0,0.00')) }}
              </td>
              <td class="text-center">
                <button
                  class="btn-link"
                  @click="onClickDownloadPdf($event, item)"
                >
                  {{ $t('documents.rt') }}
                </button>
              </td>
            </tr>
          </tbody>
        </template>
      </BaseTable>
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import tablePaginateMixin from '@/mixins/tablePaginate'
import sidebarModule from './../../sidebarModule'
import { TRANSACTION_TYPE } from '@/helpers/enum'
import UseabilityService from '../../../../api/UseabilityService'
import jwt from 'jsonwebtoken'

export default {
  mixins: [tablePaginateMixin],

  data () {
    return {
      loading: false,
      query: {
        page: this.$route.query.page || 1,
      },
    }
  },

  computed: {
    ...mapState('billing', {
      data: 'transactionList',
    }),
    ...mapGetters({
      getShopInfo: 'getShopInfo',
    }),
    empty () {
      return !this.data.length
    },
    transformData () {
      return this.data.map((item) => {
        return {
          ...item,
          description: (() => {
            return item.orders
              .reduce((acc, cur) => {
                acc.push(cur.detail)
                return acc
              }, [])
              .join(', ')
          })(),
        }
      })
    },
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.packages.title'),
      current: {
        app_name: 'packages',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 1,
    })
  },

  mounted () {
    this.fetchData()
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('billing', {
      getTransactionList: 'getTransactionList',
    }),
    async fetchData () {
      this.updateUrl()
      this.loading = true
      await this.getTransactionList({
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
      })
      this.loading = false
      this.showFinish(this.$Progress)
    },
    async onClickDownloadPdf (e, item) {
      const billCode = item.detail
      const response = await UseabilityService.getBillSingleByCode(billCode)
      const billData = response.data.data

      if (billData) {
        const billId = billData._id
        const data = {
          'type': 'ts_bill',
          'lang': this.getLang,
          'id': billId,
          'shop_id': this.getShopInfo.shop_id,
        }
        const token = jwt.sign(data, this.project.config.token.secret, { expiresIn: this.project.config.token.download_pdf_expiresin })
        const link = document.createElement('a')
        link.href = this.project.config.web.api + 'file/pdf/' + token + '/' + item.code
        link.target = '_blank'
        link.dispatchEvent(new MouseEvent('click'))
      }
    },
  },
}
</script>

<style scoped>
.btn-link {
  border: none;
  background: none;
  text-decoration: underline;
  color: var(--link-color);
  cursor: pointer;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/billingpackage/history/Index.vue